// extracted by mini-css-extract-plugin
export default {"tab__container":"styles_tab__container__PFaBx"};